import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {Col, Row, Button} from "reactstrap";
import {Select} from "../form/fields/Select";
import {api} from "../../api";
import {enums} from "../../Enums";
import {enumFormatter, getEnumOptions} from "../../utils/helper";
import {IWindow} from "../../index";

const IWindow: IWindow = (window as IWindow);
import {LGAPicker} from "../form/fields/LGAPicker";
import {WardPicker} from "../form/fields/WardPicker";
import {SenatorialDistrictPicker} from "../form/fields/SenatorialDistrictPicker";
import {FederalConstituencyPicker} from "../form/fields/FederalConstituencyPicker";
import {StateConstituencyPicker} from "../form/fields/StateConstituencyPicker";
import {Checkbox} from "../form/fields/Checkbox";
import {HasPermission} from "../HasPermission";
import {snakeCase} from "lodash";


export class ElectionPositionFormData {
    @observable election_id = IWindow.initialState.route.params.id || null;
    @observable position_id = null;
    @observable is_active = true;
    @observable level = null;
    @observable states = [];
    @observable local_government_areas = [];
    @observable wards = [];
    @observable senatorial_districts = [];
    @observable federal_constituencies = [];
    @observable state_constituencies = [];
    @observable position_check: boolean = false;
    @observable exclude: boolean = false;
}

export class ElectionPositionForm extends CrudForm {
    modelName = 'ElectionPosition';
    @observable excludeLabel: string = '';
    position_name = null;
    @observable show: boolean = false;

    constructor(props: any) {
        super(props);
        this.onClickShow = this.onClickShow.bind(this);
    }

    getData = async () => {
        if (this.id) {
            this.isLoading = true;
            await this.api.getDetailAction(this.id, {}).then((data: any) => {
                this.formStore.setValue('election_id', data.election_id);
                this.formStore.setValue('is_active', data.is_active);
                this.formStore.setValue('position_id', data.position_id);
                this.formStore.setValue('level', data.position.level);
                this.entity = data;
            });
            this.isLoading = false;
        } else {
            this.isLoading = false;
        }
    };

    stateDropDown() {
        return this.formStore.getValue('level') === 'state' ?
            <Field
                key={this.formStore.getValue('level')}
                label={this.excludeLabel + "States"}
                placeholder={this.excludeLabel + "Select States"}
                name="states"
                component={Select}
                loadOptions={() => {
                    return api.state.getListAction({
                        filters: {
                            notIds: this.entity ? this.entity.states.map((entity: any) => {
                                return entity.id
                            }) : [],
                        }
                    });
                }}
                store={this.formStore}
                multi={true}
                valueObject={true}
            /> : ''
    };

    lgaDropDown() {
        return this.formStore.getValue('level') === 'local_government_area' ?
            <Field
                label={this.excludeLabel + "Local Government Area"}
                placeholder={this.excludeLabel + "Local Government Area"}
                name="local_government_areas"
                store={this.formStore}
                component={LGAPicker}
                filters={{
                    notIds: this.entity ? this.entity.local_government_areas.map((entity: any) => {
                        return entity.id
                    }) : [],
                }}

            /> : ''
    };

    wardsDropDown() {
        return this.formStore.getValue('level') == 'ward' ?
            <Field
                label={this.excludeLabel + "Wards"}
                placeholder={this.excludeLabel + "Wards"}
                name="wards"
                store={this.formStore}
                component={WardPicker}
                filters={{
                    notIds: this.entity ? this.entity.wards.map((entity: any) => {
                        return entity.id
                    }) : [],
                }}
            /> : ''
    }

    senatorialDistrictDropDown() {
        return this.formStore.getValue('level') === 'senatorial_district' ?
            <Field
                label={this.excludeLabel + "Senatorial Districts"}
                placeholder={this.excludeLabel + "Senatorial Districts"}
                name="senatorial_districts"
                store={this.formStore}
                component={SenatorialDistrictPicker}
                filters={{
                    notIds: this.entity ? this.entity.senatorial_districts.map((entity: any) => {
                        return entity.id
                    }) : [],
                }}
            /> : ''

    }

    federalConstituencyDropDown() {
        return this.formStore.getValue('level') === 'federal_constituency' ?
            <Field
                label={this.excludeLabel + "Federal Constituencies"}
                placeholder={this.excludeLabel + "Federal Constituencies"}
                name="federal_constituencies"
                store={this.formStore}
                component={FederalConstituencyPicker}
                filters={{
                    notIds: this.entity ? this.entity.federal_constituencies.map((entity: any) => {
                        return entity.id
                    }) : [],
                }}
            /> : ''
    }

    stateConstituencyDropDown() {
        return this.formStore.getValue('level') === 'state_constituency' ?
            <Field
                label={this.excludeLabel + "State Constituencies"}
                placeholder={this.excludeLabel + "State Constituencies"}
                name="state_constituencies"
                store={this.formStore}
                component={StateConstituencyPicker}
                filters={{
                    notIds: this.entity ? this.entity.state_constituencies.map((entity: any) => {
                        return entity.id
                    }) : [],
                }}
            /> : ''
    }

    changeSelectLabel = () => {
        this.excludeLabel = '';
        if (this.formStore.getValue('exclude')) {
            this.excludeLabel = 'Exclude ';
        }
    };

    onClickShow = () => {
        this.show = !this.show;
    };

    renderFields() {
        return (
            <>

                {!this.id && <Field
                    label="Position"
                    name="position_id"
                    component={Select}
                    required={true}
                    loadOptions={api.position.getListAction}
                    store={this.formStore}
                    returnObject={true}
                    extraKey={'level'}
                    onChange={(item: any) => {
                        this.formStore.setValue('exclude', false);
                        this.formStore.setValue('level', item.extraKey);
                        this.formStore.setValue('states', null);
                        this.formStore.setValue('local_government_areas', null);
                        this.formStore.setValue('wards', null);
                        this.formStore.setValue('senatorial_districts', null);
                        this.formStore.setValue('federal_constituencies', null);
                        this.formStore.setValue('state_constituencies', null);
                        this.excludeLabel = '';
                    }}
                />}
                {this.entity &&
                <div className="form-group">
                    <label htmlFor="name" className="">Position : <strong>{this.entity.position.name}</strong></label>
                </div>
                }
                { (!this.id && this.formStore.getValue('level') &&
                this.formStore.getValue('level') != 'federal' &&
                this.formStore.getValue('level') != 'polling_unit') ?
                    <Field
                        key={'exclude-selected' + this.formStore.getValue('level')}
                        name="exclude"
                        label="Is Exclude selected?"
                        component={Checkbox}
                        required={true}
                        store={this.formStore}
                        title="Do you want to exclude from below option"
                        helpText="Note: Selected items of below select box is excluded from election when is exclude selected checkbox is checked"
                        inline={true}
                        onChange={this.changeSelectLabel}
                    />
                    :
                    ''
                }


                {this.stateDropDown()}

                {this.lgaDropDown()}

                {this.wardsDropDown()}

                {this.senatorialDistrictDropDown()}

                {this.federalConstituencyDropDown()}

                {this.stateConstituencyDropDown()}

                <Field
                    name="position_check"
                    label={"Are you sure?"}
                    component={Checkbox}
                    required={true}
                    store={this.formStore}
                    title="Postion Check"
                    helpText="Note: Position once added can not be edited or deleted"
                    inline={true}
                />
                <br/>
                <div className="clearfix">
                    {
                        this.entity &&
                        <>
                            <div className="custom-checkbox custom-control custom-control-inline clearfix mb-1">
                                <input key={"show-check"} name="show-check" id="show-check"
                                       type="checkbox" checked={this.show} onChange={this.onClickShow}
                                       className="custom-control-input"/>
                                <label
                                    className="custom-control-label" htmlFor="show-check">Show Regions Selected</label>
                            </div>
                            <br/>
                        </>
                    }

                    {this.entity && this.show && this.entity[this.entity.relation_entity] && this.entity[this.entity.relation_entity].length ?
                        this.entity[this.entity.relation_entity].map((obj: any) => {
                            return (
                                <div className="d-inline-block mr-1 mb-1" key={obj.id + this.entity.relation_entity}>
                                    <small className="bg-primary p-1 text-white">
                                        {obj.name}
                                    </small>
                                </div>
                            );
                        }, this) : ''}
                </div>
                <br/>
            </>
        );
    }
}

export class ElectionPositionFilterForm {
    @observable election_id = IWindow.initialState.route.params.id || null;
    @observable level = null;
    @observable name = null;
}

export class ElectionPositionList extends CrudList {
    modelName = 'ElectionPosition';

    @observable election: any = null;

    loadMoreData(props: any, module: any) {
        api.election.getDetailAction(IWindow.initialState.route.params.id).then((data: any) => {
            this.election = data;
        });
    }

    colums() {
        return [
            {
                name: "name",
                label: "Name",
            },
            {
                name: "level",
                label: "Level",
                formatter: enumFormatter(enums.electionLevel)
            },
            {
                name: "no_of_polling_units",
                label: "No Of Polling Units",
                 formatter: (value: any) => {
                    return (
                        <>
                            {value}
                        </>
                    )
                }

                 
            },
            {
                name: "is_polling_units_added",
                label: "Polling Units Added",
                formatter: (value: any) => {
                    return (
                        <>
                            <span className="badge badge-success">{(value) ? 'Yes' : 'No'}</span>
                        </>
                    )
                }
            },
        ];
    }

    idColumn() {
        return '';
    }

    defaultActions() {
        return {
            name: "id",
            label: "Actions",
            formatter: (value: any) => {
                return (
                    <>
                        <HasPermission module={snakeCase(this.modelName)} permission="edit">
                            <Button color="grid" onClick={() => this.props.onEdit(value)} size="sm"
                                    className="btn-edit"><span className="icon-edit"/></Button>
                        </HasPermission>
                    </>
                );
            },
            style: {whiteSpace: 'nowrap', textAlign: 'center'},
        }
    }


    renderFilters() {
        if (!this.election) {
            return null;
        }

        return (
            <Row className="form-row">
                <Col md={3}>
                    <label className={'p-3 bg-light rounded mr-2 w-100'}>{this.election.name}</label>
                </Col>

                <Col md={3}>
                    <Field
                        placeholder="Name"
                        name="name"
                        component={Input}
                        store={this.filterFormStore}
                    />
                </Col>

                <Col md={3}>
                    <Field
                        name="level"
                        placeholder="Select Level"
                        component={Select}
                        options={getEnumOptions(enums.electionLevel)}
                        store={this.filterFormStore}
                    />
                </Col>

                <Col md={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
        );
    }
}

export class ElectionPositionPage extends CrudPage {
    modelName = 'ElectionPosition';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/ElectionPositionPage.tsx